import React             from 'react';
import {BrowserRouter, 
        Switch, 
        Route}           from "react-router-dom"
import GBUI              from "./components/GBUI/GBUI"
import MainPage          from './components/Main/MainPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Switch>
        {/* メイン画面 */}
        <Route exact path="/mainpage">
          <MainPage />
        </Route>
        {/* ゲームボーイ風画面 */}
        <Route exact path="/">
          <GBUI />
        </Route>

        
      </Switch>
    </BrowserRouter>
  );
}

export default App;
